class ExperimentsStore {
    constructor() {
        this.experiments = {};
    }
    get() {
        return this.experiments;
    }
    set(experiments) {
        this.experiments = experiments;
    }
    enabled(experiment) {
        return this.experiments[experiment] === 'true';
    }
}
const isEnabled = (experiment) => () => getExperiments()[experiment] === 'true';
export const experimentsStore = new ExperimentsStore();
export const getExperiments = () => experimentsStore.get();
export const isStorageQuotaEnabled = isEnabled('specs.vod.storageQuota');
//# sourceMappingURL=experiments.js.map